export default "__VITE_ASSET__7b78f996__"